/**
 * Cart Integration
 * Routes cart icon clicks and cart:updated events to the custom Alpine.js cart drawer
 */

(function() {
  'use strict';

  function openCartDrawer() {
    window.dispatchEvent(new CustomEvent('cart:open'));
  }

  function updateBadge(count) {
    const badges = document.querySelectorAll('.header__cart-badge, .nav-pill__bag-count');
    badges.forEach(badge => {
      badge.textContent = count || 0;
      badge.setAttribute('data-cart-count', count || 0);
    });
  }

  async function fetchAndUpdateBadge() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateBadge(cart.item_count);
    } catch (e) {
      console.error('Failed to fetch cart:', e);
    }
  }

  function init() {
    // Cart icon click handler
    const cartIcon = document.querySelector('.header__cart');
    if (cartIcon) {
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    }

    // Nav pill bag button
    const bagBtn = document.querySelector('[data-cart-open]');
    if (bagBtn) {
      bagBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    }

    // Listen for cart:updated events (dispatched after add-to-cart)
    window.addEventListener('cart:updated', function(e) {
      if (e.detail && typeof e.detail.item_count !== 'undefined') {
        updateBadge(e.detail.item_count);
      } else {
        fetchAndUpdateBadge();
      }
    });

    // Initial badge count
    fetchAndUpdateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.StrataCart = {
    open: openCartDrawer,
    updateBadge: updateBadge
  };
})();
